<template>
  <modal
    name="configuration"
    :classes="['app-slideover', (hasCustomTheme()? ($theme.darkTheme ? 'bg-color-modal-dark' : 'bg-color-modal-light') : 'bg-color-modal-light')]"
    height="100%"
    :width="calculatedWidth"
    :adaptive="true"
    :pivotX="1"
    :shiftX="1"
    :pivotY="0"
    :shiftY="0"
    :scrollable="true"
    transition="slide-left"
    overlayTransition
    @before-open="onBeforeOpen"
  >
    <main :class="(hasCustomTheme() ? ($theme.darkTheme ? 'bg-color-modal-dark' : 'bg-color-modal-light') : 'bg-color-modal-light')">
      <HeaderPage pageName="Configurações" modalName="configuration" />
      <div class="container">
        <div class="row">
          <div class="item-title" :style="(!hasCustomTheme() ? '#0564b1' : {color: $theme.primaryColor})">Reprodução de vídeo</div>
        </div>

        <SwitchInput
          class="row valign-wrapper"
          icon="play_circle_outline"
          label="Auto Play"
          :darkTheme="$theme.darkTheme"
          :layoutTheme="$theme"
          :value="autoPlay"
          @input="toggleAutoPlay"
        />

        <SwitchInput
          class="row valign-wrapper"
          icon="queue_play_next"
          label="Próximo vídeo automático"
          :layoutTheme="$theme"
          :darkTheme="$theme.darkTheme"
          :value="autoNext"
          @input="toggleAutoNext"
        />

        <SwitchInput
          class="row valign-wrapper"
          icon="airplay"
          label="Continuar de onde parou"
          :layoutTheme="$theme"
          :darkTheme="$theme.darkTheme"
          :value="startFromLastSavedState"
          @input="toggleContinue"
        />

        <div class="row"></div>

        <div class="row">
          <div class="item-title" :style="(!hasCustomTheme() ? '#0564b1' : {color: $theme.primaryColor})">Geral</div>
        </div>

        <SwitchInput
          class="row valign-wrapper"
          icon="menu"
          label="Fixar menu no topo"
          :layoutTheme="$theme"
          :darkTheme="$theme.darkTheme"
          :value="fixedMenu"
          @input="toggleFixedMenu"
        />

        <!-- Notificações push (STORY-1642). Só no app: na web não há push. -->
        <template v-if="$isApp">
          <div class="row"></div>

          <div class="row">
            <div class="item-title" :style="(!hasCustomTheme() ? '#0564b1' : {color: $theme.primaryColor})">Notificações</div>
          </div>

          <div class="row push-os">
            <i class="material-icons no-padding left icon-color">{{ osState.icon }}</i>
            <div class="push-os__text">
              <div class="item-description no-padding" :style="textStyle">{{ osState.label }}</div>
              <div v-if="osState.hint" class="push-os__hint" :style="hintStyle">{{ osState.hint }}</div>
            </div>
            <button
              v-if="osState.action"
              type="button"
              class="push-os__btn"
              :style="{ color: $theme.primaryColor, borderColor: $theme.primaryColor }"
              @click="onOsAction"
            >{{ osState.action }}</button>
          </div>

          <template v-if="pushPreferencesLoaded">
            <SwitchInput
              class="row valign-wrapper"
              icon="forum"
              label="Respostas aos meus comentários"
              :layoutTheme="$theme"
              :darkTheme="$theme.darkTheme"
              :value="pushPreferences.replies"
              @input="togglePushPreference('replies')"
            />
            <p v-if="pushChannels.replies === false" class="push-note" :style="hintStyle">
              Este tipo de aviso está desligado nos ajustes do Android.
              <a href="javascript:;" :style="{ color: $theme.primaryColor }" @click="openSettings">Abrir ajustes</a>
            </p>

            <SwitchInput
              class="row valign-wrapper"
              icon="new_releases"
              label="Novas aulas e conteúdos"
              :layoutTheme="$theme"
              :darkTheme="$theme.darkTheme"
              :value="pushPreferences.newContent"
              @input="togglePushPreference('newContent')"
            />
            <p v-if="pushChannels.content === false" class="push-note" :style="hintStyle">
              Este tipo de aviso está desligado nos ajustes do Android.
              <a href="javascript:;" :style="{ color: $theme.primaryColor }" @click="openSettings">Abrir ajustes</a>
            </p>

            <div v-if="mutedCourses.length" class="push-muted">
              <div class="push-muted__title" :style="textStyle">Cursos silenciados</div>
              <p class="push-note" :style="hintStyle">
                Destes cursos você não recebe avisos de aula nova nem de resposta.
              </p>
              <div v-for="course in mutedCourses" :key="'muted_' + course.id" class="push-muted__row">
                <span class="push-muted__name" :style="textStyle">{{ course.name }}</span>
                <button
                  type="button"
                  class="push-os__btn"
                  :style="{ color: $theme.primaryColor, borderColor: $theme.primaryColor }"
                  :disabled="savingPushPreferences"
                  @click="unmuteCourse(course.id)"
                >Reativar</button>
              </div>
            </div>
          </template>
          <p v-else-if="pushPreferencesError" class="push-note" :style="hintStyle">
            Não conseguimos carregar suas preferências de notificação agora.
            <a href="javascript:;" :style="{ color: $theme.primaryColor }" @click="loadPushPreferences">Tentar de novo</a>
          </p>
        </template>
      </div>
    </main>
  </modal>
</template>

<script>
import SwitchInput
  from "@/components/SwitchInput.vue";
import HeaderPage from "@/layout/HeaderPage";
import { mapState } from "vuex";
import {
  openNotificationSettings,
  requestNotificationPermission
} from "@/services/push/notificationPermission";
import {
  refreshPushPermissionState,
  requestPushSync
} from "@/services/push/pushRegistration";

export default {
  name: "Configuration",
  props:['layoutTheme'],
  components: {
    SwitchInput,
    HeaderPage
  },
  computed: {
    ...mapState({
      autoPlay: state => state.config.autoplay,
      autoNext: state => state.config.autoNext,
      fixedMenu: state => state.config.fixedMenu,
      startFromLastSavedState: state => state.config.startFromLastSavedState,
      selectedEnroll: state => state.enroll.current,
      enrolls: state => state.enroll.enrolls,
      pushAvailable: state => state.push.available,
      pushPermission: state => state.push.permission,
      pushChannels: state => state.push.channels,
      pushPreferences: state => state.push.preferences,
      pushPreferencesLoaded: state => state.push.preferencesLoaded,
      pushPreferencesError: state => state.push.preferencesError,
      savingPushPreferences: state => state.push.savingPreferences
    }),
    textStyle() {
      return this.$theme.darkTheme ? 'color: #bfbfbf' : 'color: #333333';
    },
    hintStyle() {
      return this.$theme.darkTheme ? 'color: rgba(191, 191, 191, 0.75)' : 'color: rgba(51, 51, 51, 0.7)';
    },
    // Estado da permissão do SO: rótulo, dica e o atalho que faz sentido.
    osState() {
      if (this.pushAvailable === false) {
        return {
          icon: 'notifications_paused',
          label: 'Avisos no celular indisponíveis nesta versão do app',
          hint: 'Suas escolhas abaixo ficam salvas e passam a valer quando os avisos chegarem.',
          action: null
        };
      }
      switch (this.pushPermission) {
        case 'granted':
        case 'provisional':
          return { icon: 'notifications_active', label: 'Notificações ativadas neste aparelho', hint: null, action: 'Ajustes' };
        case 'denied':
          return {
            icon: 'notifications_off',
            label: 'Notificações desligadas neste aparelho',
            hint: 'Sem elas, os avisos abaixo não chegam até você.',
            action: 'Ativar nos Ajustes'
          };
        case 'prompt':
        case 'prompt-with-rationale':
          return {
            icon: 'notifications_none',
            label: 'Notificações ainda não autorizadas',
            hint: 'Autorize para receber os avisos que você escolher abaixo.',
            action: 'Ativar'
          };
        default:
          return { icon: 'notifications_none', label: 'Verificando as notificações do aparelho…', hint: null, action: null };
      }
    },
    mutedCourses() {
      const enrolls = this.enrolls || [];
      return (this.pushPreferences.mutedCourses || []).map(id => {
        const enroll = enrolls.find(e => Number(e.courseId) === Number(id));
        return { id, name: enroll ? enroll.name : `Curso ${id}` };
      });
    },
    calculatedWidth() {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      )
        return "100%";
      else return "20%";
    },
  },
  methods: {
    hasCustomTheme() {
      const isTrustflix = this.$route.name === "trustflix";
      return this.selectedEnroll || isTrustflix;
    },
    toggleAutoPlay() {
      this.$store.dispatch("config/autoplay", !this.autoPlay);
    },
    toggleAutoNext() {
      this.$store.dispatch("config/autoNext", !this.autoNext);
    },
    toggleFixedMenu(){
      this.$store.dispatch("config/fixedMenu", !this.fixedMenu);
    },
    toggleContinue() {
      this.$store.dispatch(
        "config/startFromLastSavedState",
        !this.startFromLastSavedState
      );
    },
    onBeforeOpen() {
      if (!this.$isApp) return;
      refreshPushPermissionState();
      this.loadPushPreferences();
    },
    loadPushPreferences() {
      this.$store.dispatch("push/loadPreferences", { force: true }).catch(() => {});
    },
    togglePushPreference(key) {
      // Sem ignorar o toque durante um PUT: o checkbox nativo já virou, e o Vue não
      // o desfaria (mostrava o contrário do salvo). A fila e a volta atrás do
      // store (push/updatePreferences) já tratam toques seguidos.
      this.$store.dispatch("push/updatePreferences", { [key]: !this.pushPreferences[key] });
    },
    unmuteCourse(courseId) {
      this.$store.dispatch("push/unmuteCourse", courseId);
    },
    openSettings() {
      // A volta dos Ajustes dispara o `resume`, que relê a permissão.
      openNotificationSettings();
    },
    async onOsAction() {
      if (this.pushPermission === 'prompt' || this.pushPermission === 'prompt-with-rationale') {
        const result = await requestNotificationPermission();
        this.$store.commit("push/SET_PERMISSION", result);
        requestPushSync("permission-settings", { force: true });
        return;
      }
      this.openSettings();
    }
  }
};
</script>

<style scoped lang="scss">
.push-os {
  display: flex;
  align-items: center;
  gap: 8px;

  &__text {
    flex: 1;
    min-width: 0;
  }

  &__hint {
    font-size: 13px;
    line-height: 1.4;
  }

  &__btn {
    flex-shrink: 0;
    padding: 6px 12px;
    border: 1px solid;
    border-radius: 16px;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
    }
  }
}

.push-note {
  margin: -6px 0 12px;
  font-size: 13px;
  line-height: 1.4;
}

.push-muted {
  margin-top: 8px;

  &__title {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 4px;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 0;
  }

  &__name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
